<template>
  <el-dialog
    title="自定义分辨率"
    :visible.sync="dialogVisible"
    width="30%"
  >
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="宽：" prop="width">
        <el-input v-model.number="form.width" size="small" placeholder="请输入宽" />
      </el-form-item>
      <el-form-item label="高：" prop="height">
        <el-input v-model.number="form.height" size="small" placeholder="请输入高" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleOk">确 定</el-button>
      <el-button @click="handleCancel">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import store from '../../../store/index.js'
import eventbus from '../../../utils/eventbus'

export default {
  name: 'InputResolution',
  data() {
    return {
      form: {
        width: null,
        height: null
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return store.state.customResolutionDialogVisible
      },
      set(val) {
        store.updateCustomResolutionDialogVisible(val)
      }
    }
  },
  methods: {
    handleCancel() {
      eventbus.$emit('INPUT_RESOLUTION')
      this.dialogVisible = false
    },
    handleOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          store.setProgramSize({ width: this.form.width, height: this.form.height })
          eventbus.$emit('INPUT_RESOLUTION', [this.form.width, this.form.height])
          this.dialogVisible = false
        }
      })
    }
  }
}
</script>
